import React from 'react';

const SaralLogoOnly = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 48 48" fill="none">
      <g clipPath="url(#clip0_16049_53455)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.0147 31.8896C32.462 29.001 32.9149 23.8647 30.0264 20.4174L29.6603 19.9806L35.5222 15.0688L35.8882 15.5056C41.4895 22.1903 40.6112 32.1501 33.9265 37.7514L29.0147 31.8896Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.4927 29.3403L18.8587 29.7771L12.9968 34.6889L12.6308 34.2521C7.02952 27.5674 7.90781 17.6076 14.5925 12.0063L19.5043 17.8682C16.057 20.7568 15.6041 25.893 18.4927 29.3403Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.6367 40.5173L26.9372 28.9424L21.6493 43.0391L36.6367 40.5173ZM11.8857 9.20481L21.5852 20.7797L26.8731 6.68299L11.8857 9.20481Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_16049_53455">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SaralLogoOnly;
